import React from 'react'

const Downloads: React.FC = () => {
	// Данные для таблиц
	const downloadLinks = [
		{
			name: 'Season6',
			version: 'v1-3.0',
			host: 'Drive',
			url: 'https://drive.google.com/file/d/1ZQI5rNDsIRyCD3opsHOA6IRgz8sx9P8O/view?usp=sharing',
		},
	]

	const problemSolutions = [
		{
			name: 'VisualRuntime C++',
			description: 'Having trouble starting the game?',
			url: 'https://muhelper.com/Tools/VisualStudioFramework.rar',
		},
		{
			name: 'Issue with Font',
			description: 'Are the fonts in-game corrupted?',
			url: 'https://muhelper.com/Tools/ARIALUNI.TTF',
		},
	]

	const requirements = [
		{
			minimum: 'Processor: Intel i3 (4th Gen+) / AMD R3 (2200+)',
			recommended: 'Processor: Intel i5 (10th Gen+) / AMD R5 (5600+)',
		},
		{ minimum: 'Memory: 4GB', recommended: 'Memory: 8GB' },
		{ minimum: 'Graphic Card: 1GB', recommended: 'Graphic Card: 2GB' },
		{ minimum: 'Hard Disk: 2GB', recommended: null },
		{ minimum: 'Operation System: Windows 10', recommended: null },
	]

	return (
		<>
			{/* Заголовок Downloads */}
			<h1 className='text-3xl font-bold text-sky-600 text-center p-10'>
				Downloads
			</h1>

			{/* Таблица с ссылками на скачивание */}
			<table className='w-full text-left border-collapse'>
				<thead>
					<tr className='bg-gray-700'>
						<th className='px-6 py-3 text-white'>Name</th>
						<th className='px-6 py-3 text-white'>Version</th>
						<th className='px-6 py-3 text-white'>Host</th>
						<th className='px-6 py-3 text-white'>Download</th>
					</tr>
				</thead>
				<tbody>
					{downloadLinks.map((link, index) => (
						<tr key={index} className='border-t border-gray-700'>
							<td className='px-6 py-4 text-sky-800'>{link.name}</td>
							<td className='px-6 py-4 text-sky-800'>{link.version}</td>
							<td className='px-6 py-4 text-sky-800'>{link.host}</td>
							<td className='px-6 py-4'>
								<a
									href={link.url}
									className='inline-block bg-sky-600 hover:bg-sky-700 text-white py-2 px-4 rounded-lg'
								>
									Downloads
								</a>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			{/* Заголовок Problems in the game? */}
			<h1 className='text-3xl font-bold text-sky-600 text-center p-10'>
				Problems in the game?
			</h1>

			{/* Таблица с решениями проблем */}
			<table className='w-full text-left border-collapse mt-6'>
				<thead>
					<tr className='bg-gray-700'>
						<th className='px-6 py-3 text-white'>Name</th>
						<th className='px-6 py-3 text-white'>Description</th>
						<th className='px-6 py-3 text-white'>Download</th>
					</tr>
				</thead>
				<tbody>
					{problemSolutions.map((solution, index) => (
						<tr key={index} className='border-t border-gray-700'>
							<td className='px-6 py-4 text-sky-800'>{solution.name}</td>
							<td className='px-6 py-4 text-sky-800'>{solution.description}</td>
							<td className='px-6 py-4'>
								<a
									href={solution.url}
									target='_blank'
									rel='noopener noreferrer'
									className='inline-block bg-sky-600 hover:bg-sky-700 text-white py-2 px-4 rounded-lg'
								>
									Downloads
								</a>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			{/* Таблица с системными требованиями */}
			<table className='w-full text-left border-collapse mt-6'>
				<thead>
					<tr className='bg-gray-700'>
						<th colSpan={2} className='px-6 py-3 text-white'>
							Requirements
						</th>
					</tr>
				</thead>
				<tbody>
					<tr className='border-t border-gray-700'>
						<td className='px-6 py-4 text-sky-800 font-semibold'>Minimum</td>
						<td className='px-6 py-4 text-sky-800 font-semibold'>
							Recommended
						</td>
					</tr>
					{requirements.map((req, index) => (
						<tr key={index} className='border-t border-gray-700'>
							<td
								className='px-6 py-4 text-sky-800'
								colSpan={req.recommended ? 1 : 2}
							>
								{req.minimum}
							</td>
							{req.recommended && (
								<td className='px-6 py-4 text-sky-800'>{req.recommended}</td>
							)}
						</tr>
					))}
				</tbody>
			</table>
		</>
	)
}

export default Downloads
